import {
  Box,
  BoxProps,
  Container,
  ContainerProps,
  Flex,
  FlexProps,
  Grid,
  GridItem,
  GridItemProps,
  GridProps,
  HStack,
  Stack,
  StackProps,
  VStack,
} from "@chakra-ui/react";
import { forwardRef } from "react";

export const ContainerComponent = forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, ...restProps }, ref) => (
    <Container ref={ref} {...restProps}>
      {children}
    </Container>
  ),
);

export const BoxComponent = forwardRef<HTMLDivElement, BoxProps>(
  ({ children, ...restProps }, ref) => (
    <Box ref={ref} {...restProps}>
      {children}
    </Box>
  ),
);

export const FlexComponent = forwardRef<HTMLDivElement, FlexProps>(
  ({ children, ...restProps }, ref) => (
    <Flex ref={ref} {...restProps}>
      {children}
    </Flex>
  ),
);

export const GridComponent = forwardRef<HTMLDivElement, GridProps>(
  ({ children, ...restProps }, ref) => (
    <Grid ref={ref} {...restProps}>
      {children}
    </Grid>
  ),
);

export const GridItemComponent = forwardRef<HTMLDivElement, GridItemProps>(
  ({ children, ...restProps }, ref) => (
    <GridItem ref={ref} {...restProps}>
      {children}
    </GridItem>
  ),
);

export const HStackComponent = forwardRef<HTMLDivElement, StackProps>(
  ({ children, ...restProps }, ref) => (
    <HStack ref={ref} {...restProps}>
      {children}
    </HStack>
  ),
);

export const VStackComponent = forwardRef<HTMLDivElement, StackProps>(
  ({ children, ...restProps }, ref) => (
    <VStack ref={ref} {...restProps}>
      {children}
    </VStack>
  ),
);

export const StackComponent = forwardRef<HTMLDivElement, StackProps>(
  ({ children, ...restProps }, ref) => (
    <Stack ref={ref} {...restProps}>
      {children}
    </Stack>
  ),
);

export { Wrap, WrapItem } from "@chakra-ui/react";
